import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ToastService } from '@core/services/toast.service';
import { IReportSearch } from '../interfaces/ireport-search';
import { IRequiredReportFields } from '../interfaces/irequired-report-fields';
import { ReportService } from '@core/services/report.service';
import { take } from 'rxjs';
import { IActivityBankReport } from '@core/interfaces/iactivity-bank-report';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'drdp-activity-bank',
  standalone: false,
  templateUrl: './activity-bank.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './activity-bank.component.scss'
})
export class ActivityBankComponent {
  loading: boolean = false;
  reportData: IActivityBankReport[] = [];

  private reportService = inject(ReportService);
  private toastService = inject(ToastService);
  private translocoService = inject(TranslocoService);

  requiredFields: IRequiredReportFields = {
    state: true,
    agency: true,
    globalRatingPeriod: true,
    site: true,
    classroom: true,
    ageGroup: false,
    requireMultipleRatingPeriods: false,
    requireRpInSameSchoolYear: false
  };

  showReport(searchValues: IReportSearch): void {
    this.loading = true;
    this.reportService.generateActivityBankReportData(searchValues)
      .pipe(take(1))
      .subscribe((res: IActivityBankReport[]) => {
        this.reportData = res;
        this.loading = false;
        if (!res?.length) {
          this.toastService.error(this.translocoService.translate('reports.messages.noChildrenToDisplay'));
        }
      });
  }

  downloadReport(searchValues: IReportSearch) {
    this.loading = true;
    this.reportService
      .generateActivityBankReportPdf(searchValues)
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          if (!res || res.size === 0) {
            this.toastService.error(this.translocoService.translate('reports.messages.noDataToDownload'));
            return;
          }
          const file = new Blob([res], { type: 'application/pdf' });
          const fileUrl = URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = fileUrl;
          let fileName = `activity_bank_report`;
          link.download = `${fileName.replace(/ /g, '_')}.pdf`;
          link.click();
        },
        complete: () => {
          this.loading = false;
        },
      });
  }
}
